import React from 'react'

import AbsenteeismRiskIndicator from './AbsenteeismRiskIndicator'
import AbsenteeismSummary from './AbsenteeismSummary'

function AbsenteeismIndicator({ absentPercentage, enableRiskIndicator = false }) {
  if (!absentPercentage) return null

  if (enableRiskIndicator) {
    return <AbsenteeismRiskIndicator absentPercentage={absentPercentage} />
  }

  return <AbsenteeismSummary absentPercentage={absentPercentage} />
}

export default AbsenteeismIndicator
